import { Feedback } from "../pages/health/encounters/cards/vitals/types/commonCDSTypes";

export const bmiRanges = {
  underweight: [0, 18.4],
  normal: [18.5, 24.9],
  overweight: [25, 29.9],
  obesityClassI: [30, 34.9],
  obesityClassII: [35, 39.9],
  obesityClassIII: [40, Infinity],
} as const;

export function calculateBmiFeedback(bmiValue: number): Feedback {
  if (Number.isNaN(bmiValue) || bmiValue < 0) {
    return { message: "Invalid BMI value", type: "error" };
  }

  if (bmiValue === Infinity) {
    return { message: "Invalid BMI calculation", type: "error" };
  }

  if (
    bmiValue >= bmiRanges.underweight[0] &&
    bmiValue <= bmiRanges.underweight[1]
  ) {
    return {
      message: "Underweight - Consider nutritional assessment",
      type: "warning",
    };
  }

  if (bmiValue >= bmiRanges.normal[0] && bmiValue <= bmiRanges.normal[1]) {
    return { message: "Normal BMI range", type: "success" };
  }

  if (
    bmiValue >= bmiRanges.overweight[0] &&
    bmiValue <= bmiRanges.overweight[1]
  ) {
    return {
      message: "Overweight - Consider lifestyle modifications",
      type: "warning",
    };
  }

  if (
    bmiValue >= bmiRanges.obesityClassI[0] &&
    bmiValue <= bmiRanges.obesityClassI[1]
  ) {
    return {
      message: "Obesity Class I - Medical evaluation recommended",
      type: "error",
    };
  }

  if (
    bmiValue >= bmiRanges.obesityClassII[0] &&
    bmiValue <= bmiRanges.obesityClassII[1]
  ) {
    return {
      message: "Obesity Class II - Medical intervention needed",
      type: "error",
    };
  }

  if (bmiValue >= bmiRanges.obesityClassIII[0]) {
    return {
      message: "Obesity Class III - Immediate medical attention required",
      type: "error",
    };
  }

  return { message: "BMI value outside expected range", type: "warning" };
}
